import React, {useCallback, useEffect, useState} from 'react';
import {Menu, Col, Drawer} from 'antd';
import {MenuOutlined} from '@ant-design/icons';
import {Route, Link, Switch, useLocation} from 'react-router-dom';
import {Header, Footer} from './components';
import {About, Home, OurService, Contact} from './pages';
import './App.css';
import 'antd/dist/antd.css';
import NavigationTitle from './components/text/NavigationTitle';
import Container from './components/wrapper/Container';
import MenuWrapper from './components/wrapper/MenuWrapper';
import ContentWrapper from './components/wrapper/ContentWrapper';
import LayoutWrapper from './components/wrapper/LayoutWrapper';
import DrawerContent from './components/drawer';
import Avatar from './components/avatar';
import {ThemeProvider} from 'styled-components';
import {GlobalStyle, themes} from './theme';
import LZRow from './components/grid/LZRow';
import BackTopStyled from './components/backtop';

const items = [
  {key: '1', label: 'Home', path: '/'},
  {key: '2', label: 'Our Product', path: '/products'},
  {key: '3', label: 'About', path: '/about'},
  {key: '4', label: 'Contact', path: '/contact'},
];

const DEFAULT_KEY = 1;

function App() {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(() => {
    const item = items.find((_item) => location.pathname === _item.path);
    if (item) {
      return item.key;
    } else {
      return DEFAULT_KEY;
    }
  });
  useEffect(() => {
    const item = items.find((_item) => location.pathname === _item.path);
    if (item) {
      setCurrentPage(item.key);
    } else {
      setCurrentPage(DEFAULT_KEY);
    }
  }, [location]);

  const onMenuClick = useCallback(
    (e) => {
      setCurrentPage(e.key);
    },
    [setCurrentPage]
  );

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  return (
    <ThemeProvider theme={themes.light}>
      <GlobalStyle />
      <BackTopStyled />
      <LayoutWrapper>
        <Header />
        <ContentWrapper>
          <Container>
            <LZRow marginbottom="1rem">
              <Col span="6">
                <Avatar />
              </Col>
              <Col span="12">
                <MenuWrapper
                  selectedKeys={[currentPage]}
                  onClick={onMenuClick}
                  mode="horizontal"
                >
                  {items.map((item) => (
                    <Menu.Item key={item.key}>
                      <NavigationTitle>{item.label}</NavigationTitle>
                      <Link to={item.path} />
                    </Menu.Item>
                  ))}
                </MenuWrapper>
              </Col>
              <Col
                span="6"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <MenuOutlined
                  style={{fontSize: 20, margin: 'auto'}}
                  onClick={showDrawer}
                />
              </Col>
            </LZRow>
          </Container>

          <Drawer
            title="About Us"
            placement="right"
            closable={false}
            onClose={onClose}
            visible={visible}
            getContainer={false}
          >
            <DrawerContent />
          </Drawer>

          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/products" component={OurService} />
            <Route exact path="/about" component={About} />
            <Route exact path="/contact" component={Contact} />
          </Switch>
        </ContentWrapper>

        <Footer />
      </LayoutWrapper>
    </ThemeProvider>
  );
}

export default App;
